export default __webpack_public_path__ + "static/media/ic_ghana.98cf14c0.svg";